// components/HomePage.js
import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { connectWallet, disconnectWallet, truncateString } from './utils/walletUtils';

const HomePage = () => {
  const [connected, setConnected] = useState(false);
  const [shortAddress, setshortAddress] = useState('');
  const [showDisconnect, setShowDisconnect] = useState(false);
  const [kikaHolder, setKikaHolder] = useState(false);
  const disconnectRef = useRef(null);

  useEffect(() => {
    if (window.localStorage.getItem('walletStatus')) {
      let ordinalAddress = window.localStorage.getItem('ordinalAddress');
      setConnected(true);
      const truncatedText = truncateString(ordinalAddress);
      setshortAddress(truncatedText);
    }
  }, []);

  const handleButtonClick = async () => {
    if (!connected) {
      await connectWallet(setConnected, setshortAddress);
    }
    const address = window.localStorage.getItem('ordinalAddress');
    if (!address) {
      alert('Please connect your wallet first!');
      return;
    }
    const amount = await checkKikaHolder(address);
    if (amount > 0) {
      alert(`You hold ${amount} Kika!`);
    } else {
      alert('No Kika held.');
    }
  };

  const handleClickOutside = (event) => {
    if (disconnectRef.current && !disconnectRef.current.contains(event.target)) {
      setShowDisconnect(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const showDisconnectBtn = (event) => {
    event.preventDefault();
    setShowDisconnect(!showDisconnect);
  };

  const handleDisconnect = (event) => {
    event.stopPropagation();
    disconnectWallet(setConnected, setShowDisconnect);
    setShowDisconnect(false);
  };

  const checkKikaHolder = async (address) => {
    const runeId = '865305:4115';
    try {
      const response = await axios.get(`https://open-api.unisat.io/v1/indexer/address/${address}/runes/${runeId}/balance`, {
        headers: {
          Authorization: `Bearer a9c682be4439467ba0b2c1d6a7f0bbda99bce7bab05239ef7799c1590edf84e1`, // API key from environment variable
          accept: 'application/json',
        },
      });
      const data = response.data;
      if (data.code === 0 && data.data && parseInt(data.data.amount) > 0) {
        setKikaHolder(true);
        const divisibility = data.data.divisibility;
        const amount = parseInt(data.data.amount);
        const calculatedAmount = amount / Math.pow(10, divisibility);
        return calculatedAmount;
      }
    } catch (error) {
      console.error('Error fetching rune balance:', error);
    }
    return 0;
  };

  return (
    <div id="top">
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <a className="navbar-brand" href="/">
              <img src="kiss.png" alt="Logo" width="69" className="d-inline-block align-top" />
            </a>
            <div className="d-flex" ref={disconnectRef}>
              <a href="https://x.com/sendkika" target="blank" className="me-2">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://discord.gg/6XDen5uugq" target="blank" className="me-2">
                <i className="fab fa-discord"></i>
              </a>
              {showDisconnect && (
                <div className="disconnect-menu">
                  <button className="btn btn-danger mt-2" onClick={handleDisconnect}>
                    Disconnect
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
      <div className="content">
        <iframe
          width="100%"
          height="300"
          scrolling="no"
          frameBorder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1903919967&color=%23fbaef0&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
          title="SoundCloud Player"
        ></iframe>
       <br />
        <button className="button" onClick={handleButtonClick}>
          Check balance 🥳🐇
        </button>
      </div>
    </div>
  );
};

export default HomePage;